import { Flex, Text } from "@fluentui/react-northstar";
import { Card, Progress } from "antd";
import React from "react";
import {
  ArrowUpOutlined,
  ArrowDownOutlined,
  DownloadOutlined,
  ExclamationCircleOutlined,
  CheckCircleOutlined,
  InfoCircleOutlined,
  WarningOutlined,
  ClockCircleOutlined,
  SearchOutlined,
} from "@ant-design/icons";

const GradingTime = ({
  gradingTime = {
    averageTime: 3.7,
    unit: "minutes",
    improvement: {
      percentage: 55,
      description: "faster",
    },
    progressPercentage: 40,
  },
}) => {
  return (
    <Card style={{ height: "100%", borderRadius: "8px" }} className="shadow">
      <Flex space="between" fill>
        <Text>{"Avg Time to Grade"}</Text>
        {gradingTime?.improvement?.percentage > 0 && (
          <Text style={{ color: "#2563eb", fontWeight: 500 }}>
            <ClockCircleOutlined style={{ marginRight: 4 }} />
            {gradingTime.improvement.percentage}%{" "}
            {gradingTime.improvement.description}
          </Text>
        )}
      </Flex>
      <div style={{ margin: "16px 0 8px 0" }}>
        <span style={{ fontSize: 32, fontWeight: 700, color: "#222" }}>
          {gradingTime.averageTime}
        </span>
        <span style={{ fontSize: 18, color: "#888", marginLeft: 4 }}>
          {gradingTime.unit}
        </span>
      </div>
      <div style={{ marginTop: 32 }}>
        <Progress
          percent={gradingTime.progressPercentage}
          showInfo={false}
          strokeColor="#2563eb"
          style={{ height: 12, borderRadius: 8 }}
        />
      </div>
    </Card>
  );
};

export default GradingTime;
